// removed by extract-text-webpack-plugin
module.exports = {"Tuple":"_10YxD","Divider":"_2hEBJ","ContainerPrimary":"_3Z1Eu","ContainerSecondary":"_19c2u","ContainerTertiary":"_1rH8y","AirlineLogo":"_38idj","HorizontalDivider":"_3Ewdq","HorizontalLine":"_8RJZ_","Details":"_1lPGN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/InternationalTupleRoundTrip/InternationalTupleRoundTrip.scss
// module id = 839
// module chunks = 0